<template>
  <div class="about">
    <!-- Hero Section -->
    <section class="hero">
      <div class="container">
        <h1>打造智慧物联网卡云平台 为万物互联赋能</h1>
        <p>用科技改变生活  用智能温暖世界</p>
      </div>
    </section>

    <!-- Company Introduction -->
    <section class="company-intro">
      <div class="container">
        <h2 class="section-title">公司简介</h2>
        <el-row :gutter="30">
          <el-col :xs="24" :md="24">
            <div class="intro-content">
              <p class="intro-para" style="color:#409EFF">我们是谁?</p>
              <p class="intro-para">深圳市桔子智联信息技术有限公司管理团队在物联网行业已深耕10多年，是国内领先的物联网智能终端设备无线通讯接入服务提供商。我们致力于把基站网络信号覆盖最好、套餐最经济、开通续费查询最便捷的运营商流量卡管理平台提供给广大物联网设备用户，构建万物互联的智能世界。</p>
              <p class="intro-para" style="color:#409EFF">谁影响我们?</p>
              <p class="intro-para">桔子智联对内依靠努力奋斗的员工，以奋斗者为本，让有贡献者得到合理回报；对外依靠客户和合作伙伴，坚持以客户为中心，不断创新产品和服务为客户创造价值；构建客户、供应商、员工、股东共赢的生态圈。</p>
              <p class="intro-para">公司现已和中国移动、中国电信、中国联通三大运营商建立了稳固的战略合作关系。公司自主研发的“无线物联网流量卡管理服务平台”，具有客户套餐灵活设置、用户流量自行充值、流量统计查询、用户管理、渠道管理、计费营帐等功能。领先的物联网流量卡管理服务平台，深得运营商、经销商、物联网智能设备厂商、行业用户广泛地认可和好评。</p>
              <p class="intro-para">5G时代万物互联，智慧连接和场景化体验驱动新业务需求日益涌现。面对物联网蓬勃发展带来的机遇和挑战，公司将不断挖掘行业用户、物联网智能设备厂商需求，随需而变，致力于成为物联网行业三大运营商领先的渠道服务商；让用户享受更智能、更快捷的物联网通信服务。</p>
              <p class="intro-para">随着公司的不断发展壮大，将不断融合物联网产业需求，全面推进物联网运营管理服务平台战略升级，寻求可持续健康发展，实现企业价值稳健增长，回报员工、股东和社会。</p>
              <p class="intro-para">公司深耕物联网行业多年，已为超过<span style="color:#ff6b35;font-weight:bold">10000+</span>不同行业的客户提供专业服务，平台在线激活设备超过<span style="color:#ff6b35;font-weight:bold">5000万</span>个，业务覆盖<span style="color:#ff6b35;font-weight:bold">200+</span>个国家和地区。凭借优质的服务和稳定的产品，桔子智联已成为众多企业信赖的物联网通信解决方案提供商。</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- Stats Section -->
    <section class="stats-section">
      <div class="container">
        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-number">10,000<span>+</span></div>
            <div class="stat-label">服务不同行业的客户</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">5000<span>万+</span></div>
            <div class="stat-label">平台在线激活设备</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">200<span>+</span></div>
            <div class="stat-label">覆盖国家和地区</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Company Culture -->
    <section class="company-culture">
      <div class="container">
        <h2 class="section-title">企业文化</h2>
        <el-row :gutter="30">
          <el-col :xs="24" :sm="12" :md="6" v-for="(culture, index) in cultures" :key="index">
            <div class="culture-card">
              <i :class="culture.icon"></i>
              <h3>{{ culture.title }}</h3>
              <p>{{ culture.description }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- Development History -->
    <section class="history">
      <div class="container">
        <h2 class="section-title">发展历程</h2>
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in history"
            :key="index"
            :timestamp="activity.year"
            :type="activity.type"
          >
            {{ activity.content }}
          </el-timeline-item>
        </el-timeline>
      </div>
    </section>

    <!-- Contact -->
    <section class="contact">
      <div class="container">
        <h2>加入我们</h2>
        <el-row :gutter="30">
          <el-col :xs="24" :sm="12">
            <div class="contact-info">
              <h3>联系方式</h3>
              <p><i class="el-icon-phone"></i> 400-188-0608</p>
              <p><i class="el-icon-message"></i> 611699108@qq.com</p>
              <p><i class="el-icon-location"></i> 深圳南山区深南大道10128号南山数字文化产业基地西塔1103</p>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div class="contact-form">
              <el-form :model="form" :rules="rules" ref="form" label-width="80px">
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                  <el-input v-model="form.email"></el-input>
                </el-form-item>
                <el-form-item label="电话" prop="phone">
                  <el-input v-model="form.phone"></el-input>
                </el-form-item>
                <el-form-item label="留言" prop="message">
                  <el-input type="textarea" v-model="form.message" rows="4"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitForm">提交</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {
      cultures: [
        {
          icon: 'el-icon-aim',
          title: '企业使命',
          description: '用科技创新推动产业升级，让物联网技术惠及更多领域'
        },
        {
          icon: 'el-icon-view',
          title: '企业愿景',
          description: '成为物联网行业的领军企业，引领行业发展方向'
        },
        {
          icon: 'el-icon-star-on',
          title: '核心价值观',
          description: '创新、诚信、协作、共赢'
        },
        {
          icon: 'el-icon-trophy',
          title: '企业精神',
          description: '追求卓越，永不止步'
        }
      ],
      history: [
        {
          year: '2016年',
          content: '公司成立，开始物联网技术研发',
          type: 'primary'
        },
        {
          year: '2021年',
          content: '获得高新技术企业认证',
          type: 'success'
        },
        {
          year: '2022年',
          content: '成功开发多个行业解决方案',
          type: 'warning'
        },
        {
          year: '2023年',
          content: '获得多项技术专利',
          type: 'info'
        },
        {
          year: '2024年',
          content: '业务范围扩展至全国',
          type: 'primary'
        }
      ],
      team: [
        {
          name: '张三',
          position: '创始人 & CEO',
          description: '物联网领域专家，拥有15年行业经验',
          avatar: require('@/assets/images/team1.jpg')
        },
        {
          name: '李四',
          position: '技术总监',
          description: '专注于物联网技术研发，多项专利发明人',
          avatar: require('@/assets/images/team2.jpg')
        },
        {
          name: '王五',
          position: '产品总监',
          description: '负责产品规划和市场策略',
          avatar: require('@/assets/images/team3.jpg')
        },
        {
          name: '赵六',
          position: '运营总监',
          description: '负责公司运营和客户服务',
          avatar: require('@/assets/images/team4.jpg')
        }
      ],
      form: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        message: [
          { required: true, message: '请输入留言内容', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 这里添加表单提交逻辑
          this.$message.success('提交成功！')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.about {
  .hero {
    background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('../assets/images/about.jpg');
    background-size: cover;
    background-position: center;
    height: 400px;
    display: flex;
    align-items: center;
    color: #fff;
    text-align: center;
    
    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
      
      h1 {
        font-size: 48px;
        margin-bottom: 20px;
      }
      
      p {
        font-size: 24px;
      }
    }
  }
  
  .section-title {
    text-align: center;
    font-size: 36px;
    margin-bottom: 50px;
    color: #2c3e50;
  }
  
  .stats-section {
    padding: 80px 0;
    background: linear-gradient(135deg, #fff 0%, #fff8f5 100%);
    position: relative;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 80%;
      height: 2px;
      background: linear-gradient(90deg, transparent, #ff6b35, transparent);
    }
    
    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
    }
    
    .stats-grid {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 80px;
      flex-wrap: wrap;
    }
    
    .stat-item {
      text-align: center;
      padding: 20px 40px;
      
      .stat-number {
        font-size: 56px;
        font-weight: 700;
        color: #ff6b35;
        line-height: 1.2;
        
        span {
          font-size: 32px;
          font-weight: 600;
          color: #ff8c5a;
        }
      }
      
      .stat-label {
        font-size: 18px;
        color: #666;
        margin-top: 10px;
        font-weight: 500;
      }
    }
  }
  
  .company-intro {
    padding: 20px 0;
    
    .intro-content {
      h2 {
        font-size: 32px;
        margin-bottom: 30px;
        color: #2c3e50;
      }
      
      p {
        color: #666;
        line-height: 1.8;
        margin-bottom: 20px;
      }

      .intro-para {
        color: #666;
        line-height: 1.8;
        margin-bottom: 20px;
        text-indent: 2em; // 首行缩进2个字符
        text-align: justify; // 两端对齐
      }
    }
    
    .intro-image {
      img {
        width: 100%;
        border-radius: 8px;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      }
    }
  }
  
  .company-culture {
    padding: 20px 0;
    background: #f8f9fa;
    
    .culture-card {
      height: 168px;
      text-align: center;
      padding: 30px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      margin-bottom: 30px;
      
      i {
        font-size: 48px;
        color: #409EFF;
        margin-bottom: 20px;
      }
      
      h3 {
        font-size: 20px;
        margin-bottom: 15px;
        color: #2c3e50;
      }
      
      p {
        color: #666;
        line-height: 1.6;
      }
    }
  }

  .history {
    padding: 80px 0;
    
    .el-timeline {
      max-width: 800px;
      margin: 0 auto;
    }
  }
  
  .team {
    padding: 80px 0;
    background: #f8f9fa;
    
    .team-card {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      margin-bottom: 30px;
      
      .member-avatar {
        height: 200px;
        overflow: hidden;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      
      .member-info {
        padding: 20px;
        text-align: center;
        
        h3 {
          font-size: 20px;
          margin-bottom: 5px;
          color: #2c3e50;
        }
        
        .position {
          color: #409EFF;
          margin-bottom: 10px;
        }
        
        .description {
          color: #666;
          line-height: 1.6;
        }
      }
    }
  }
  
  .contact {
    padding: 80px 0;
    
    .contact-info {
      h3 {
        font-size: 24px;
        margin-bottom: 20px;
        color: #2c3e50;
      }
      
      p {
        color: #666;
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        
        i {
          margin-right: 10px;
          color: #409EFF;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .about {
    .hero {
      height: 300px;
      
      .container {
        h1 {
          font-size: 32px;
        }
        
        p {
          font-size: 18px;
        }
      }
    }
    
    .stats-section {
      padding: 40px 0;
      
      .stats-grid {
        gap: 30px;
      }
      
      .stat-item {
        padding: 15px 20px;
        
        .stat-number {
          font-size: 40px;
          
          span {
            font-size: 24px;
          }
        }
        
        .stat-label {
          font-size: 16px;
        }
      }
    }
    
    .company-intro {
      .intro-content {
        margin-bottom: 30px;
      }
    }
  }
}</style> 